import { SelfAttributionOption } from '@/models/self-attribution-source'

const SELF_ATTRIBUTION_SOURCE_DIRECT_MAIL = 'DirectMail'
/** @deprecated */
const SELF_ATTRIBUTION_SOURCE_IN_GAME_ADVERT = 'InGameAdvert' // Archived
const SELF_ATTRIBUTION_SOURCE_MEDIA = 'NewsMedia'
export const SELF_ATTRIBUTION_SOURCE_OTHER = 'Other'
const SELF_ATTRIBUTION_SOURCE_OUTDOOR = 'Outdoor'
/** @deprecated */
const SELF_ATTRIBUTION_SOURCE_RADIO = 'Radio' // Archived
/** @deprecated */
const SELF_ATTRIBUTION_SOURCE_PRINT_AD = 'PrintAd' // Archived
const SELF_ATTRIBUTION_SOURCE_SEARCH = 'Search'
const SELF_ATTRIBUTION_SOURCE_SOCIAL = 'Social'
const SELF_ATTRIBUTION_SOURCE_TV = 'Tv'
const SELF_ATTRIBUTION_SOURCE_WEBSITE = 'PartnerOrWebsite'
const SELF_ATTRIBUTION_SOURCE_WORD_OF_MOUTH = 'WordOfMouth'
export const SELF_ATTRIBUTION_SOURCE_RATHER_NOT_SAY = 'RatherNotSay'
/** @deprecated */
const SELF_ATTRIBUTION_SOURCE_CROWDCUBE = 'Crowdcube' // Archived
const SELF_ATTRIBUTION_SOURCE_YOUTUBE = 'YouTube'
const SELF_ATTRIBUTION_SOURCE_INFLUENCER = 'Influencer'

export const SELF_ATTRIBUTION_SOURCE_TITLES = {
    [SELF_ATTRIBUTION_SOURCE_CROWDCUBE]: 'Crowdcube',
    [SELF_ATTRIBUTION_SOURCE_DIRECT_MAIL]: 'A letter via the post',
    [SELF_ATTRIBUTION_SOURCE_IN_GAME_ADVERT]: 'Game advert',
    [SELF_ATTRIBUTION_SOURCE_MEDIA]: 'A news article (print or online)',
    [SELF_ATTRIBUTION_SOURCE_OTHER]: 'Other',
    [SELF_ATTRIBUTION_SOURCE_OUTDOOR]: 'Tube, tram or train advert',
    [SELF_ATTRIBUTION_SOURCE_PRINT_AD]: 'Newspaper or magazine advert',
    [SELF_ATTRIBUTION_SOURCE_RADIO]: 'Radio advert',
    [SELF_ATTRIBUTION_SOURCE_SEARCH]: 'Search (e.g. Google, ChatGPT)',
    [SELF_ATTRIBUTION_SOURCE_SOCIAL]: 'Social media (e.g. Instagram)',
    [SELF_ATTRIBUTION_SOURCE_TV]: 'TV advert',
    [SELF_ATTRIBUTION_SOURCE_WEBSITE]: 'Through another website or app',
    [SELF_ATTRIBUTION_SOURCE_WORD_OF_MOUTH]: 'A recommendation (e.g. from a friend)',
    [SELF_ATTRIBUTION_SOURCE_YOUTUBE]: 'YouTube',
    [SELF_ATTRIBUTION_SOURCE_INFLUENCER]: 'An Influencer',
} as const

const DEFAULT_SELF_ATTRIBUTION_OPTIONS: SelfAttributionOption[] = [
    {
        value: SELF_ATTRIBUTION_SOURCE_SEARCH,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_SEARCH],
    },
    {
        value: SELF_ATTRIBUTION_SOURCE_YOUTUBE,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_YOUTUBE],
    },
    {
        value: SELF_ATTRIBUTION_SOURCE_WORD_OF_MOUTH,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_WORD_OF_MOUTH],
    },
    {
        value: SELF_ATTRIBUTION_SOURCE_SOCIAL,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_SOCIAL],
    },
    {
        value: SELF_ATTRIBUTION_SOURCE_TV,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_TV],
    },
    {
        value: SELF_ATTRIBUTION_SOURCE_OUTDOOR,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_OUTDOOR],
    },
    {
        value: SELF_ATTRIBUTION_SOURCE_INFLUENCER,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_INFLUENCER],
    },
    {
        value: SELF_ATTRIBUTION_SOURCE_WEBSITE,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_WEBSITE],
    },
    {
        value: SELF_ATTRIBUTION_SOURCE_DIRECT_MAIL,
        title: SELF_ATTRIBUTION_SOURCE_TITLES[SELF_ATTRIBUTION_SOURCE_DIRECT_MAIL],
    },
]

// Shuffle the options, to avoid the bias of the first option being selected
export const SHUFFLED_SELF_ATTRIBUTION_OPTIONS = DEFAULT_SELF_ATTRIBUTION_OPTIONS.sort(() => Math.random() - 0.5)
